<template>
    <div
        class="DebouncedInput"
        :class="status"
    >
        <WInput
            v-model="localStringValue"
            :name="id"
            :placeholder="placeholder.toString()"
            :min="min"
            :max="max"
            type="number"
            :align="align"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import debounce from 'lodash/debounce'

export default {
    name: 'WDebouncedNumberInput',
    props: {
        id: VueTypes.string,
        value: VueTypes.number.isRequired,
        placeholder: VueTypes.number.isRequired,
        min: VueTypes.number.def(NaN),
        max: VueTypes.number.def(NaN),
        align: VueTypes.oneOf(['left', 'center', 'right']).def('right'),
        debounceWait: VueTypes.number.def(1000),
    },
    data () {
        return {
            localStringValue: this.value.toString(),
        }
    },
    computed: {
        sanitizedValue () {
            const val = parseInt(this.localStringValue, 10)
            if (typeof this.min === 'number' && val < this.min) return this.min
            if (typeof this.max === 'number' && val > this.max) return this.max
            return val
        },
        status () {
            if (!this.isMounted && this.localStringValue) return undefined
            if (this.sanitizedValue.toString() !== this.localStringValue) {
                return 'error'
            }
            if (this.localStringValue !== this.value.toString()) {
                return 'changed'
            }
            return undefined
        },
    },
    watch: {
        localStringValue () {
            this.debouncedRefresh()
        },
        value () {
            this.localStringValue = this.value.toString()
        },
    },
    mounted () {
        this.isMounted = true
    },
    created () {
        this.localStringValue = this.sanitizedValue.toString()
        this.debouncedRefresh = debounce(this.refresh, this.debounceWait)
    },
    methods: {
        refresh () {
            if (this.status === 'error') {
                this.localStringValue = this.sanitizedValue.toString()
            } else if (this.status === 'changed') {
                this.$emit('input', this.sanitizedValue, this.id)
            }
        },
    },
}
</script>

<style lang="scss">
.DebouncedInput {
    .WInput input {
        margin-bottom: 0;
    }
    &.changed input {
        color: $accent-blue !important;
        border-color: $accent-blue !important;
    }
    &.error input {
        color: $danger !important;
        border-color: $danger !important;
    }
}
</style>
